import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MainService } from "../../Services/service.service";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SubscribtionService } from '../../Services/subscribtion.service';
import { CreditCardValidator } from 'angular-cc-library';
import { AddPremiumAdToken, AddWriteAdToken } from '../../api/WickedApiClient';

export enum PaymentType { PremiumAdToken = 0, WriteAdToken = 1, ThirdPartyToken = 2  }

@Component({
  selector: 'premium-ad-token-payment',
  templateUrl: './premium-ad-token-paymen.component.html',
  styleUrls: ['./premium-ad-token-payment.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PremiumAdTokenPayment implements OnInit {
  public form: FormGroup;

  protected creating: boolean = false;

  @Input() paymentFormType: PaymentType = PaymentType.PremiumAdToken;

  @Input() payButtonText: string = "";

  @Output() onTokenAdded = new EventEmitter();

  private _termsNotAccepted: boolean = true;
  
  public get termsNotAccepted(): boolean {
    return this._termsNotAccepted;
  }
  public set termsNotAccepted(value: boolean) {
    this._termsNotAccepted = value;
  }

  constructor(public service: MainService, private fb: FormBuilder, private subscribtionService: SubscribtionService) { }

  ngOnInit() {
    this.form = this.fb.group({
      firstName: ['', [<any>Validators.required]],
      lastName: ['', [<any>Validators.required]],
      zip: ['', [<any>Validators.required]],
      creditCard: ['', [<any>CreditCardValidator.validateCCNumber]],
      expirationDateYear: ['', [<any>Validators.required]],
      expirationDateMonth: ['', [<any>Validators.required]],
      cvc: ['', [<any>Validators.required, <any>Validators.minLength(3), <any>Validators.maxLength(4)]],
    });
  }

  get isThirdPartyPayment(){
    return this.paymentFormType == PaymentType.ThirdPartyToken;
  }

  onSubmitPremiumAdToken() {
    if (this.form.dirty && this.form.valid) {
      let data: AddPremiumAdToken = new AddPremiumAdToken({
        firstName: this.form.controls["firstName"].value,
        lastName: this.form.controls["lastName"].value,
        cardNumber: this.form.controls["creditCard"].value,
        expirationDate: `${this.form.controls["expirationDateYear"].value}-${this.form.controls["expirationDateMonth"].value}`,
        zip: this.form.controls["zip"].value,
        securityCode: this.form.controls["cvc"].value,
      })
      this.creating = true;
      this.subscribtionService.createPremiumAdToken(data).then((response) => {
        this.creating = false;
        this.onTokenAdded.emit(response);
      });
    }
  }

  onSubmitWriteAdToken() {
    if (this.form.dirty && this.form.valid) {
      let data: AddWriteAdToken = new AddWriteAdToken({
        firstName: this.form.controls["firstName"].value,
        lastName: this.form.controls["lastName"].value,
        cardNumber: this.form.controls["creditCard"].value,
        expirationDate: `${this.form.controls["expirationDateYear"].value}-${this.form.controls["expirationDateMonth"].value}`,
        zip: this.form.controls["zip"].value,
        securityCode: this.form.controls["cvc"].value,
      })
      this.creating = true;
      this.subscribtionService.createWriteAdToken(data).then((response) => {
        this.creating = false;
        this.onTokenAdded.emit(response);
      });
    }
  }

  onSubmitThirdPartyAdToken() {
    if (this.form.dirty && this.form.valid) {
      if(!this.termsNotAccepted){
        let data: AddPremiumAdToken = new AddPremiumAdToken({
          firstName: this.form.controls["firstName"].value,
          lastName: this.form.controls["lastName"].value,
          cardNumber: this.form.controls["creditCard"].value,
          expirationDate: `${this.form.controls["expirationDateYear"].value}-${this.form.controls["expirationDateMonth"].value}`,
          zip: this.form.controls["zip"].value,
          securityCode: this.form.controls["cvc"].value,
        })
        this.creating = true;
        this.subscribtionService.createThirdPartyAdToken(data).then((response) => {
          this.creating = false;
          this.onTokenAdded.emit(response);
        });
      }else{
        this.service.showError("Please accept terms");
      }
    }
  }

  onSubmit() {
    switch (this.paymentFormType) {
      case PaymentType.PremiumAdToken: this.onSubmitPremiumAdToken(); break;
      case PaymentType.WriteAdToken: this.onSubmitWriteAdToken(); break;
      case PaymentType.ThirdPartyToken: this.onSubmitThirdPartyAdToken(); break;
    }
    
  }

  public termsAcceptAction(e) {
    this.termsNotAccepted = !e.checked
  }
}



